import { useTranslate } from 'hooks/useTranslate';

import BeneficiaryPlanDetails from 'modules/beneficiaries/components/BeneficiaryPlanDetails';

const DetailsTab = ({ beneficiary, society, plan }) => {
  const { t } = useTranslate();
  return (
    <div className="card-inner p-0">
      <h6>{t('PlanDetail')}</h6>
      <p className="text-justify">
        {t('PlanInvitationOfSoc', { societyName: society?.name })}
      </p>

      <BeneficiaryPlanDetails
        plan={plan}
        society={society}
        beneficiary={beneficiary}
      />

      <p className="mt-3 mb-0">{t('YouWillHaveCopyWithDetails')}</p>
    </div>
  );
};

export default DetailsTab;
